<template>
  <div v-if="dataPrepared">
    <b-row>
      <b-col cols="12">
        <div
          class="d-flex justify-content-between align-items-center pt-50 mb-2"
        >
          <div>
            <h2 class="font-weight-bolder m-0">
              Gestión documental
            </h2>
          </div>
          <div
            v-if="role != 'operario'"
            class="d-flex align-items-center"
          >
            <div>
              <b-button
                variant="primary"
                class="mr-1 text-nowrap"
                @click="modalShowDocuments = true"
              >
                {{ "Añadir archivo" }}
              </b-button>
            </div>
          </div>
        </div>
        <b-card
          v-for="category in items"
          v-if="itemsPorCategoria[category.id] && itemsPorCategoria[category.id].length"
          :key="category.id"
        >
          <h3 class="mb-2">
            {{ category.name }}
          </h3>
          <b-row v-if="itemsPorCategoria[category.id] && itemsPorCategoria[category.id].length">
            <b-col
              v-for="item in itemsPorCategoria[category.id]"
              :key="item.id"
              :md="3"
              class="mb-1"
            >
              <div>
                <a
                  v-if="!item.archive_url"
                  :href="item.external_url"
                  target="_blank"
                  class="text-dark d-flex p-1 rounded-1 justify-content-between e-document"
                >
                  <div>
                    <feather-icon
                      icon="FileTextIcon"
                      size="20"
                      class="mr-1"
                    />
                    {{ item.name }}
                  </div>
                  <span
                    v-if="role != 'operario'"
                    class="d-inline-block px-50 text-danger cursor-pointer"
                    @click.stop.prevent="deleteDocument($event, item.id, item.name)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </span>
                </a>
                <private-file-download
                  v-if="item.archive_url"
                  :file-url="item.archive_url"
                  :file-name="item.name"
                >
                  <span
                    v-if="role != 'operario'"
                    class="d-inline-block px-50 text-danger cursor-pointer"
                    @click.stop.prevent="deleteDocument($event, item.id, item.name)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </span>
                </private-file-download>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-documents"
      v-model="modalShowDocuments"
      :title="modalTitle"
      size="lg"
      hide-footer
      no-close-on-backdrop
      centered
    >
      <div
        v-if="optionModal == 0"
        class="py-1"
      >
        <b-row>
          <b-col :md="6">
            <b-button
              class="py-2_5"
              variant="outline-primary"
              block
              @click="optionModal = 2"
            >
              <feather-icon
                icon="FolderIcon"
                size="20"
              />
              <p class="mb-0 mt-0_5">
                Subida masiva
              </p>
            </b-button>
          </b-col>
          <b-col :md="6">
            <b-button
              class="py-2_5"
              variant="outline-primary"
              block
              @click="optionModal = 1"
            >
              <feather-icon
                icon="FileIcon"
                size="20"
              />
              <p class="mb-0 mt-0_5">
                Subida individual
              </p>
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div v-if="optionModal == 1">
        <create-document
          :show-user-select="true"
          :show-back-button="true"
          @back="optionModal = 0"
        />
      </div>
      <div v-if="optionModal == 2">
        <create-document-bulk
          :show-back-button="true"
          @back="optionModal = 0"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BCard,
  BButton,
  BCol,
  BRow,
  BModal,
} from 'bootstrap-vue'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import CreateDocument from '@/views/documents/CreateDocument.vue'
import CreateDocumentBulk from '@/views/documents/CreateDocumentBulk.vue'
import documentsApi from '@/api/documents-api'
import PrivateFileDownload from '@/components/ui/PrivateFileDownload.vue'
export default {
  components: {
    BModal,
    BCard,
    BButton,
    BCol,
    BRow,
    CreateDocument,
    CreateDocumentBulk,
    PrivateFileDownload,
  },
  data() {
    return {
      optionModal: 0,
      dataPrepared: false,
      modalShowDocuments: false,
      itemsPorCategoria: {}, // Nuevo objeto para guardar los items por categoría
    }
  },
  computed: {
    ...mapGetters({
      user: 'users/getUser',
      items: 'documents/getItemsCategories',
      currentClient: 'clients/getCurrentClient',
      role: 'auth/getRole',
    }),
    modalTitle() {
      if (this.optionModal === 1) return 'Subida individual'
      if (this.optionModal === 2) return 'Subida masiva'
      return 'Documentos'
    },
  },
  async created() {
    await this.chargeData()
    await this.cargarItemsPorCategoria() // Llamada para cargar los items de cada categoría
  },
  methods: {
    ...mapActions({
      list: 'documents/getListCategories',
      delete: 'documents/deleteDocument',
    }),
    async chargeData() {
      await this.list({
        page: 1,
        per_page: 9999,
        search: '',
        active: 1,
        client_id: this.currentClient.id,
      })
    },
    async cargarItemsPorCategoria() {
      if (!this.items || !this.items.length) return
      for (const category of this.items) {
        try {
          const response = await documentsApi.listDocuments(this.currentClient.id, '', category.id)
          this.$set(this.itemsPorCategoria, category.id, response.data.data || [])
        } catch (e) {
          this.$set(this.itemsPorCategoria, category.id, [])
        }
      }
      this.dataPrepared = true
    },
    deleteDocument(event, id, name) {
      if (event) event.stopPropagation()
      this.$bvModal
        .msgBoxConfirm(`¿Estás seguro de eliminar ${name}?`, {
          bodyClass: 'bodyDelete',
          footerClass: 'footerDelete',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'outline-danger',
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.delete(id)
          }
        })
    },
  },
}
</script>
